export const FETCH_REPORTS_REQUEST = 'REPORTS/FETCH_REPORTS_REQUEST';
export const FETCH_REPORTS_SUCCESS = 'REPORTS/FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAILURE = 'REPORTS/FETCH_REPORTS_FAILURE';

export const DOWNLOAD_REPORT_REQUEST = 'REPORTS/DOWNLOAD_REPORT_REQUEST';
export const DOWNLOAD_REPORT_SUCCESS = 'REPORTS/DOWNLOAD_REPORT_SUCCESS';
export const DOWNLOAD_REPORT_FAILURE = 'REPORTS/DOWNLOAD_REPORT_FAILURE';
